import { useState, useEffect } from 'react';
import { useAuthContext } from '../contexts/AuthContext';
import api from '../lib/api';

export interface AuthOrgInfo {
  orgId: string;
  orgName: string;
  orgDomain: string;
  role: string;
  isCurrent: boolean;
}

export function useAuthOrgs() {
  const { user, login } = useAuthContext();
  const [orgs, setOrgs] = useState<AuthOrgInfo[]>([]);

  useEffect(() => {
    if (!user) return;
    api
      .get<AuthOrgInfo[]>('/auth/orgs')
      .then((res) => setOrgs(res.data))
      .catch(() => {});
  }, [user]);

  const current = orgs.find((o) => o.isCurrent);
  const hasMultiple = orgs.length > 1;

  const switchOrg = async (orgId: string) => {
    try {
      const res = await api.post<{ token: string }>('/auth/switch-org', { orgId });
      login(res.data.token);
      window.location.reload();
    } catch {
      // Handled by axios interceptor
    }
  };

  return { orgs, current, hasMultiple, switchOrg };
}
